import { Mail } from 'lucide-react';

const SubscriptionFaqs = () => {
  return (
    <section className="grid grid-cols-1 md:grid-cols-3 gap-4 pb-4">
      <div className="rounded-2xl border border-slate-200 bg-white p-5">
        <h2 className="font-semibold text-slate-900">What counts as a voucher?</h2>
        <p className="mt-2 text-sm leading-6 text-slate-500">
          One voucher = one trip for one traveller group. Unused vouchers don&apos;t roll over; your count resets on the renewal date.
        </p>
      </div>
      <div className="rounded-2xl border border-slate-200 bg-white p-5">
        <h2 className="font-semibold text-slate-900">When do I earn?</h2>
        <p className="mt-2 text-sm leading-6 text-slate-500">
          On Pro and above, commission is credited to your wallet per booking your traveller completes in your app. You&apos;ll see it on the App bookings page, line by line.
        </p>
      </div>
      <div className="rounded-2xl border border-slate-200 bg-white p-5">
        <div className="flex items-center gap-2">
          <Mail className="w-4 h-4 text-[#067978]" />
          <h2 className="font-semibold text-slate-900">Can I switch billing cycles?</h2>
        </div>
        <p className="mt-2 text-sm leading-6 text-slate-500">
          Yes. You can switch between monthly and annual plans at any time. Annual plans come with an instant 20% discount on 12 months.
        </p>
      </div>
    </section>
  );
};

export default SubscriptionFaqs;
